import styled, { css } from 'styled-components';

import { FilterActionWrapper } from '@pkg/components/Sections/Profile/Filters/Filter/FilterAction/styles';
import { StyledList } from '@pkg/components/Sections/Profile/Filters/Filter/FilterContent/styles';

export const FadeDiv = styled.div<{ noFade?: boolean }>`
    background: linear-gradient(180deg, rgba(9, 7, 25, 1) 0%, rgba(9, 7, 25, 0) 100%);
    pointer-events: none;
    z-index: 2;
    width: 100%;
    height: 10px;
    position: absolute;

    ${(props) =>
        props.noFade &&
        css`
            background: none;
        `}
`;

export const LoadMoreButtonWrapper = styled.div<{ noFade?: boolean }>`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #090719;
    margin-top: 10px;
    margin-bottom: 10px;

    ${(props) =>
        props.noFade &&
        css`
            background: none;
        `}
`;

export const GroupFilterCollectionsOverride = styled.div`
    ${StyledList} {
        row-gap: 5px;
    }

    ${FilterActionWrapper} {
        width: 100%;
    }
`;
